import React, { useEffect, useState } from 'react'

import { useModal } from '@/contexts/ModalContext'

import ImageNext from '@/components/ImageNext'
import DecorativeCircle from '@/components/DecorativeCircle'
import ModalButton, { ModalButtonSettings } from '../../ModalButton'

import * as S from './styles'

export interface AlertStyleModalConfig {
  img: {
    URL: string
    width: number
    height: number
    alt: string
  }
  title: string
  text: React.ReactNode
  buttons?: Array<ModalButtonSettings>
  circles?: Array<{
    top: string
    left: string
    radius: number
    thickness: number
  }>
  showCloseButton?: boolean
  extraClasses?: string
}

interface AlertStyleModalProps {
  config: AlertStyleModalConfig
}

const AlertStyleModal = ({ config }: AlertStyleModalProps) => {
  const { closeModal } = useModal()

  const [modalClass, setModalClass] = useState<string>()

  useEffect(() => {
    let name = 'modal-alert'
    if (config.extraClasses) {
      name += ` ${config.extraClasses}`
    }

    setModalClass(name)
  }, [config])

  return (
    config && (
      <div className={modalClass}>
        <S.AlertImgContainer>
          {config.circles?.map((info, i) => (
            <DecorativeCircle
              key={i}
              top={info.top}
              left={info.left}
              radius={info.radius}
              thickness={info.thickness}
            />
          ))}

          <ImageNext
            src={config.img.URL}
            width={config.img.width}
            height={config.img.height}
            alt={config.img.alt}
            className="alert-img"
          />

          {(config.showCloseButton || !config.buttons) && (
            <button id="btn_close_alert" type="button" onClick={closeModal}>
              <span className="material-icons-round">close</span>
            </button>
          )}
        </S.AlertImgContainer>

        <S.AlertTextContainer>
          <p className="title">{config.title}</p>
          {config.text}
          {config.buttons && (
            <div className="flexbox v-centered">
              {config.buttons.map((btn, i) => (
                <ModalButton key={i} settings={btn} />
              ))}
            </div>
          )}
        </S.AlertTextContainer>
      </div>
    )
  )
}

export default AlertStyleModal
